import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import NavDropdown from 'react-bootstrap/NavDropdown';

const NavBarNew = ({ onSelect }) => {
  const { t, i18n } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);
  const [activeSection, setActiveSection] = useState("Home"); // 👈 HOME activo al cargar

  const lngs = {
    en: { nativeName: 'English' },
    esp: { nativeName: 'Español' }
  };

  // Detecta desktop/móvil
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNavClick = (section) => {
    setActiveSection(section);   // 👈 marca activo
    onSelect(section);
    setIsOpen(false);
  };

  const handleLanguageClick = (lang) => {
    i18n.changeLanguage(lang);
    setIsOpen(false);
  };

  return (
    <nav className="navbar navbar-expand-lg text-uppercase fixed-top" id="mainNav">
      <div className="container font-face-montserrat">

        {/* Logo */}
        <button
          className="navbar-brand btn p-0 homeicon"
          onClick={() => handleNavClick("Home")}
        >
          <img src="./logo.png" width="45" height="45" alt="Home" />
        </button>

        <button
          id="burger"
          className="navbar-toggler text-uppercase font-weight-bold text-white rounded"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
        >
          <i className="fas fa-bars"></i>
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`} id="navbarResponsive">

          {/* Links principales */}
          <div className="navBarCenteredCol">
            <ul className="navbar-nav align-text-center menu">

              <li className="nav-item mx-0 mx-lg-1">
                <button
                  onClick={() => handleNavClick("Home")}
                  className={`nav-link py-3 px-0 px-lg-3 rounded navbutton btn ${
                    activeSection === "Home" ? "active" : ""
                  }`}
                >
                  Game Audio
                </button>
              </li>

              <li className="nav-item mx-0 mx-lg-1">
                <button
                  onClick={() => handleNavClick("Films")}
                  className={`nav-link py-3 px-0 px-lg-3 rounded navbutton btn ${
                    activeSection === "Films" ? "active" : ""
                  }`}
                >
                  Films
                </button>
              </li>

              <li className="nav-item mx-0 mx-lg-1">
                <button
                  onClick={() => handleNavClick("Contact")}
                  className={`nav-link py-3 px-0 px-lg-3 rounded navbutton btn ${
                    activeSection === "Contact" ? "active" : ""
                  }`}
                >
                  {t('Contact')}
                </button>
              </li>

            </ul>
          </div>

          {/* Idioma */}
          <div className="col justify-content-end">
            <ul className="navbar-nav justify-content-end menu">
              <li>
                {isDesktop ? (
                  <NavDropdown
                    className="menu"
                    id="basic-nav-dropdown"
                    title={lngs[i18n.resolvedLanguage].nativeName}
                  >
                    {i18n.resolvedLanguage !== "en" && (
                      <NavDropdown.Item onClick={() => handleLanguageClick("en")}>
                        <span className="topBarText font-face-CabinSketch languajebtn">
                          {lngs.en.nativeName}
                        </span>
                      </NavDropdown.Item>
                    )}
                    {i18n.resolvedLanguage !== "esp" && (
                      <NavDropdown.Item onClick={() => handleLanguageClick("esp")}>
                        <span className="topBarText font-face-CabinSketch languajebtn">
                          {lngs.esp.nativeName}
                        </span>
                      </NavDropdown.Item>
                    )}
                  </NavDropdown>
                ) : (
                  <div className="mobile-language-dropdown menu mt-2">
                    {i18n.resolvedLanguage !== "en" && (
                      <button
                        onClick={() => handleLanguageClick("en")}
                        className="nav-link py-2 px-3 font-face-CabinSketch menu languajebtn btn"
                      >
                        English
                      </button>
                    )}
                    {i18n.resolvedLanguage !== "esp" && (
                      <button
                        onClick={() => handleLanguageClick("esp")}
                        className="nav-link py-2 px-3 font-face-CabinSketch menu languajebtn btn"
                      >
                        Español
                      </button>
                    )}
                  </div>
                )}
              </li>
            </ul>
          </div>

        </div>
      </div>
    </nav>
  );
};

export default NavBarNew;
